import React from 'react';
import { Lock } from 'lucide-react';
interface WelcomeStepProps {
  onNext: () => void;
}
export function WelcomeStep({
  onNext
}: WelcomeStepProps) {
  return <div className="flex flex-col h-full px-6 py-12 bg-white" data-id="element-75">
      {/* Logo Area */}
      <div className="flex flex-col items-center justify-center mt-12 mb-auto" data-id="element-76">
        <div className="w-16 h-16 rounded-xl bg-[#b8a06a] flex items-center justify-center text-white font-bold text-3xl mb-4 shadow-lg shadow-[#b8a06a]/20" data-id="element-77">
          DC
        </div>
        <h1 className="text-[#1a1a2e] font-bold text-2xl leading-tight" data-id="element-78">
          DermaClinic
        </h1>
        <p className="text-[#b8a06a] text-xs font-bold tracking-widest mt-1" data-id="element-79">
          3D SIMULATION
        </p>
      </div>

      {/* Content Area */}
      <div className="flex flex-col items-center text-center mb-12" data-id="element-80">
        <h2 className="text-3xl font-bold text-[#1a1a2e] mb-4 leading-tight" data-id="element-81">
          See your results before surgery
        </h2>
        <p className="text-[#6b7280] text-base px-2" data-id="element-82">
          Upload 3 photos and we'll create your personalized 3D visualization in
          minutes.
        </p>
      </div>

      {/* Actions */}
      <div className="mt-auto flex flex-col gap-6" data-id="element-83">
        <button onClick={onNext} className="w-full bg-[#b8a06a] hover:bg-[#a08d5a] text-white font-semibold py-4 rounded-xl transition-colors shadow-lg shadow-[#b8a06a]/20 active:scale-[0.98]" data-id="element-84">
          Start — it's free
        </button>

        <div className="flex items-center justify-center gap-2 text-[#6b7280] text-sm" data-id="element-85">
          <Lock className="w-4 h-4" data-id="element-86" />
          <span data-id="element-87">Your photos are private and secure. HIPAA compliant.</span>
        </div>
      </div>
    </div>;
}